import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { VideoUploadOnFeedFragmentDoc } from '../../../media/video-uploads/__generated__/video-uploads-query.generated';
import { StepImageUploadOnFeedFragmentDoc } from '../../../media/step-image-uploads/__generated__/step-image-upload.fragment.generated';
export type ShowContactSettingsFragment = { __typename?: 'InitiationItem', showContact: boolean, showContactName: boolean, showContactAvatar: boolean, showContactJobTitle: boolean, showCompanySymbol: boolean, showCompanyName: boolean };

export type TeleprompterSettingsFragment = { __typename?: 'InitiationItem', useTeleprompter: boolean, teleprompterScript?: string | null, teleprompterSpeed?: number | null, teleprompterFontSize?: number | null, teleprompterFontColor?: string | null };

export type InitiationItemBgSettingsFragment = { __typename?: 'InitiationItem', blurEffect?: number | null, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle?: number | null, colors?: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> | null };

export type ShoppableInteractionOnInitiationItemFragment = { __typename: 'ShoppableInteraction', count: number, shoppableInteractionId: string, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, customCtaText?: string | null, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> };

export type MultipleChoiceInteractionOnInitiationItemFragment = { __typename: 'MultipleChoiceInteraction', multipleChoiceInteractionId: string, question: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } };

export type HotspotInteractionOnInitiationItemFragment = { __typename: 'HotspotInteraction', hotspotInteractionId: string, hotspots: Array<{ __typename?: 'Hotspot', id: string, x: number, y: number, text: string, textColor: string, bgColor: string, alwaysShowText: boolean, destinationType?: Types.NextInteractionType | null, value?: string | null, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null } }> };

export type InitiationItemDetailContentFragment = { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, oembedResult?: any | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, name?: string | null, rawUrl?: string | null, alternativeText?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, thumbUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null, duration?: number | null, size?: number | null, insertedAt?: any | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null, chapters?: Array<{ __typename?: 'NarrationChapter', id: string, title?: string | null, slidePageNumber?: number | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null }> | null } | null, file?: { __typename?: 'FileUpload', id: string, name?: string | null, size?: number | null, pageCount?: number | null, mimeType?: string | null, fileUrl?: string | null } | null, formFields?: Array<{ __typename?: 'AudioField' } | { __typename?: 'EmailField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'LongTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'PhoneField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'ShortTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'VideoField' } | null> | null };

export type InitiationItemDetailQuestionFragment = { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> };

export type InitiationItemDetailForEditorFragment = { __typename?: 'InitiationItem', id: string, databaseId: any, title: string, headline?: string | null, type: Types.InitiationItemType, interactionType: Types.InteractionType, order: number, collectContact: boolean, useTextFallback: boolean, textColor?: string | null, blurEffect?: number | null, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle?: number | null, useTeleprompter: boolean, teleprompterScript?: string | null, teleprompterSpeed?: number | null, teleprompterFontSize?: number | null, teleprompterFontColor?: string | null, showContact: boolean, showContactName: boolean, showContactAvatar: boolean, showContactJobTitle: boolean, showCompanySymbol: boolean, showCompanyName: boolean, interactions: Array<{ __typename: 'HotspotInteraction', id: string, type: Types.InteractionType, hotspotInteractionId: string, hotspots: Array<{ __typename?: 'Hotspot', id: string, x: number, y: number, text: string, textColor: string, bgColor: string, alwaysShowText: boolean, destinationType?: Types.NextInteractionType | null, value?: string | null, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null } }> } | { __typename: 'MultipleChoiceInteraction', id: string, type: Types.InteractionType, multipleChoiceInteractionId: string, question: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } } | { __typename: 'ShoppableInteraction', id: string, type: Types.InteractionType, count: number, shoppableInteractionId: string, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, customCtaText?: string | null, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> }>, question?: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } | null, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, oembedResult?: any | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, name?: string | null, rawUrl?: string | null, alternativeText?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, thumbUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null, duration?: number | null, size?: number | null, insertedAt?: any | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null, chapters?: Array<{ __typename?: 'NarrationChapter', id: string, title?: string | null, slidePageNumber?: number | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null }> | null } | null, file?: { __typename?: 'FileUpload', id: string, name?: string | null, size?: number | null, pageCount?: number | null, mimeType?: string | null, fileUrl?: string | null } | null, formFields?: Array<{ __typename?: 'AudioField' } | { __typename?: 'EmailField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'LongTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'PhoneField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'ShortTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'VideoField' } | null> | null } | null, colors?: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> | null };

export const InitiationItemBgSettingsFragmentDoc = gql`
    fragment InitiationItemBgSettings on InitiationItem {
  colors {
    r
    g
    b
    a
    hex
  }
  blurEffect
  bgType
  bgGradientType
  bgGradientAngle
}
    `;
export const TeleprompterSettingsFragmentDoc = gql`
    fragment TeleprompterSettings on InitiationItem {
  useTeleprompter
  teleprompterScript
  teleprompterSpeed
  teleprompterFontSize
  teleprompterFontColor
}
    `;
export const ShowContactSettingsFragmentDoc = gql`
    fragment ShowContactSettings on InitiationItem {
  showContact
  showContactName
  showContactAvatar
  showContactJobTitle
  showCompanySymbol
  showCompanyName
}
    `;
export const ShoppableInteractionOnInitiationItemFragmentDoc = gql`
    fragment ShoppableInteractionOnInitiationItem on ShoppableInteraction {
  __typename
  count
  shoppableInteractionId
  shoppableProducts {
    id
    ctaType
    customCtaText
    product {
      id
      currencyCode
      onlineStoreUrl
      sourceType
      sourceId
      title
      images {
        id
        src
      }
      variants {
        id
        originalPrice
        price
      }
    }
  }
}
    `;
export const MultipleChoiceInteractionOnInitiationItemFragmentDoc = gql`
    fragment MultipleChoiceInteractionOnInitiationItem on MultipleChoiceInteraction {
  __typename
  multipleChoiceInteractionId
  question {
    id
    title
    titleColor
    showTitle
    timing
    choices {
      id
      type
      hasNext
      text
      value
      order
      middleInteraction {
        id
        type
        question
        embed {
          id
          linkUrl
          oembedResult
          status
          reason
        }
      }
      nextPage {
        id
        title
        type
        order
      }
    }
  }
}
    `;
export const HotspotInteractionOnInitiationItemFragmentDoc = gql`
    fragment HotspotInteractionOnInitiationItem on HotspotInteraction {
  __typename
  hotspotInteractionId
  hotspots {
    id
    x
    y
    text
    textColor
    bgColor
    alwaysShowText
    destinationType
    value
    middleInteraction {
      id
      type
      question
      embed {
        id
        linkUrl
        oembedResult
        status
        reason
      }
    }
  }
}
    `;
export const InitiationItemDetailQuestionFragmentDoc = gql`
    fragment InitiationItemDetailQuestion on PageQuestion {
  id
  title
  titleColor
  showTitle
  timing
  choices {
    id
    type
    hasNext
    text
    value
    order
    middleInteraction {
      id
      type
      question
      embed {
        id
        linkUrl
        oembedResult
        status
        reason
      }
    }
    nextPage {
      id
      title
      type
      order
    }
  }
}
    `;
export const InitiationItemDetailContentFragmentDoc = gql`
    fragment InitiationItemDetailContent on Content {
  id
  type
  groupType
  body
  label
  plainDescription
  embedLink
  oembedResult
  providerName
  videoContain
  video {
    ...VideoUploadOnFeed
  }
  image {
    ...StepImageUploadOnFeed
  }
  narration {
    id
    title
    type
    video {
      id
      rawUrl
      transcodedUrl
      previewUrl
      streamUrl
      gifUrl
      gifWithIconUrl
    }
    chapters {
      id
      title
      slidePageNumber
      video {
        id
        rawUrl
        transcodedUrl
        previewUrl
        streamUrl
        gifUrl
        gifWithIconUrl
      }
    }
  }
  file {
    id
    name
    size
    pageCount
    mimeType
    fileUrl
  }
  formFields {
    ... on EmailField {
      id
      key
      label
      isRequired
      isHidden
    }
    ... on ShortTextField {
      id
      key
      label
      isRequired
      isHidden
    }
    ... on LongTextField {
      id
      key
      label
      isRequired
      isHidden
    }
    ... on PhoneField {
      id
      key
      label
      isRequired
      isHidden
    }
  }
}
    ${VideoUploadOnFeedFragmentDoc}
${StepImageUploadOnFeedFragmentDoc}`;
export const InitiationItemDetailForEditorFragmentDoc = gql`
    fragment InitiationItemDetailForEditor on InitiationItem {
  id
  databaseId
  title
  headline
  type
  interactionType
  order
  collectContact
  useTextFallback
  textColor
  ...InitiationItemBgSettings
  ...TeleprompterSettings
  ...ShowContactSettings
  interactions {
    id
    type
    ... on ShoppableInteraction {
      ...ShoppableInteractionOnInitiationItem
    }
    ... on MultipleChoiceInteraction {
      ...MultipleChoiceInteractionOnInitiationItem
    }
    ... on HotspotInteraction {
      ...HotspotInteractionOnInitiationItem
    }
  }
  question {
    ...InitiationItemDetailQuestion
  }
  content {
    ...InitiationItemDetailContent
  }
}
    ${InitiationItemBgSettingsFragmentDoc}
${TeleprompterSettingsFragmentDoc}
${ShowContactSettingsFragmentDoc}
${ShoppableInteractionOnInitiationItemFragmentDoc}
${MultipleChoiceInteractionOnInitiationItemFragmentDoc}
${HotspotInteractionOnInitiationItemFragmentDoc}
${InitiationItemDetailQuestionFragmentDoc}
${InitiationItemDetailContentFragmentDoc}`;